import { readCookie } from '../utils/cookie_helper';
export var ValidPageServiceEnv;
(function (ValidPageServiceEnv) {
    ValidPageServiceEnv["production"] = "production";
    ValidPageServiceEnv["qa"] = "qa";
})(ValidPageServiceEnv || (ValidPageServiceEnv = {}));
export var isValidPageServiceEnv = function (rawEnv) {
    return Object.keys(ValidPageServiceEnv).includes(rawEnv);
};
/**
 * return the release version we report to Sentry
 * based on the environment it is served from
 * and if this is manual testing
 * @returns `Web sha the FE app built from (in QA or manual testing)` `semVer (in production)` `local (anywhere else)`
 */
export var getReleaseVersion = function (env, webSha, packageVersion) {
    var _a, _b, _c;
    if (webSha === void 0) { webSha = process.env.WEB_SHA || 'UNKNOW_WEB_SHA'; }
    if (packageVersion === void 0) { packageVersion = process.env.PACKAGE_VERSION ||
        'UNKNOWN_PACKAGE_VERSION'; }
    if (env === ValidPageServiceEnv.qa) {
        return webSha;
    }
    if (env === ValidPageServiceEnv.production) {
        // if we use web-sha for manual testing (in query param or cookie)
        // we don't want to report the semVer because it will be misleading and send false signal
        var containManualWebShaInCookie = !!readCookie('doordash-web-env-app-corp-consumer-portal');
        var containWebShaInQueryParam = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) === null || _b === void 0 ? void 0 : _b.includes('?web-sha')) !== null && _c !== void 0 ? _c : false;
        return containManualWebShaInCookie || containWebShaInQueryParam
            ? webSha
            : packageVersion;
    }
    if (!env) {
        return 'local';
    }
    return webSha;
};
